import * as React from "react";
import chromaPurple from "../../../public/Purp.png";
// Import your PNGs (or use URLs). Example with bundlers:
//import chromaBlue from "../assets/chroma-blue.png";
//import chromaRainbow from "../assets/chroma-rainbow.png";
//import chromaEmerald from "../assets/chroma-emerald.png";

export type ChromaVariant = "blue" | "purple" | "rainbow" | "emerald";

type Props = {
  size?: number | string;          // same feel as lucide (defaults to 1em)
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
  variant?: ChromaVariant;         // which PNG to show
};


const VARIANT_SRC: Record<ChromaVariant, string> = {
  blue: chromaPurple,
  purple: chromaPurple,
  rainbow: chromaPurple,
  emerald: chromaPurple,
};

export function ChromaIcon({
  size = "1em",
  className,
  style,
  alt = "Chroma",
  variant = "purple",
}: Props) {
  const dimension = typeof size === "number" ? `${size}px` : size;

  return (
    <img
      src={VARIANT_SRC[variant]}
      alt={alt}
      className={className}
      style={{
        width: dimension,
        height: dimension,
        display: "inline-block",
        objectFit: "contain",
        imageRendering: "pixelated",   // keeps that crisp pixel look
        ...style,
      }}
      draggable={false}
    />
  );
}

export default ChromaIcon;
